// KATTINTÁSKOR KÉRT friss letöltés — a mellékletek közös útja (Évi #79)
//
// a listában kapott presigned URL az Odin `FILE_URL_TTL`-je (alapból 5 perc) után lejár, a lap viszont tovább
// nyitva marad: aki később kattint, a tár „lejárt" hibalapját kapná. Ezért a link kattintáskor a BFF-től kér
// friss URL-t, és arra navigál. A tár minden letöltést `Content-Disposition: attachment` fejléccel ad, tehát a
// navigáció letölt, a lapot nem hagyja el (új fül nem kell — az a `window.open` await utáni popup-tiltásába futna).

/**
 * Lekéri a friss URL-t és elindítja a letöltést. `false`, ha nincs URL (a hívó jelez hibát) — dobni nem dob.
 */
export async function downloadFresh(resolve: () => Promise<string | null>): Promise<boolean> {
  let url: string | null;
  try {
    url = await resolve();
  } catch {
    // a hálózati hiba ugyanaz a felhasználónak, mint a hiányzó URL — a hívó toastot ad
    url = null;
  }
  // mélységi védelem: csak http(s) URL-re navigálunk (egy hibás upstream `javascript:` értéke sem futhat le)
  if (!url || !/^https?:\/\//i.test(url)) return false;
  window.location.assign(url);
  return true;
}
